import React from 'react';
import IvisNk9Logo from '../../assets/IvisNk9Logo.png';
import './PublicHeader.css';

const PublicHeader = () => {
    return (
        <header className="public-header">
            <div className="public-header-container">
                <div className="public-header-logo-section">
                    <div className="public-logo-container">
                        <img src={IvisNk9Logo} alt="IVIS NK9 Logo" className="public-header-logo" />
                    </div>
                </div>

                <div className="public-header-content-section">
                    <div className="public-header-center">
                        <h1 className="public-app-title">Módulo Integrado de Inspecciones</h1>
                        <p className="public-app-description">
                            Administra, actualiza y lleva a cabo inspecciones de vehículos pendientes de póliza.
                        </p>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default PublicHeader;